/**
 * * Class FormValidationBrochures that handles base functionality for .....
 * @class
 */
class FormValidationBrochures {

    /**
     * Make a new FormValidationBrochures.
     * @constructs
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {

        this._element = element;
        this._options = options;

        this._form = this._element;
        this._submitBtn = this._form.querySelector('[type="submit"]');
        this._initialize();

    }

    /**
     * _initialize
     * @private
     */
    _initialize() {

        this._onSubmitBind = () => this._onSubmit();
        this._onChangeBind = () => this._onChange();

        this._form.addEventListener('submit', this._onSubmitBind);
        this._form.addEventListener('change', this._onChangeBind);
    }

    /**
     * Handles form submitting when a change event occurs
     * @private
     */
    _onSubmit() {
        event.preventDefault();
        let error = this._checkOrderAmount();
        if (error.status === 0) {
            this._form.submit();
        } else {
            this._showError(error);
        }

    }

    /**
     * _onChange()
     * @private
     */
    _onChange() {
        this._hideError();
    }

    /**
     * _hideshowError()
     * @private
     */
    _hideError() {
        let errorMessage = this._form.querySelector('[aria-hidden="false"]');
        if (errorMessage) {
            errorMessage.setAttribute('aria-hidden', 'true');
        }
        this._submitBtn.removeAttribute('disabled');
    }

    /**
     * _showError()
     * @private
     * @param {Object} error - the error object with info about the error
     */
    _showError = error => {
        let errorMessage;

        /* eslint-disable */
        if (error.status === 1) {
            if (error.detail === 'minNrOfItemsDeceded') {
                errorMessage = this._form.querySelector('[data-errormessage="minNrOfItemsDeceded"]');
            } else if (error.detail === 'maxNrOfItemsExceeded') {
                errorMessage = this._form.querySelector('[data-errormessage="maxNrOfItemsExceeded"]');
            }

            if (errorMessage) {
                errorMessage.setAttribute('aria-hidden', 'false');
            }
        }

        this._submitBtn.setAttribute('disabled', 'disabled');
        /* eslint-enable */
    }

    /**
     * _checkMinOrderAmount
     * @returns {boolean} - check if all brochures have nr of items between min and max amount.
     * @private
     */
    _checkOrderAmount() {
        let arrValidInputs = [];
        let error = {
            status: 0,
            detail: ''
        };
        let numberInputs = Array.prototype.slice.call(this._form.querySelectorAll('[type="number"]'));
        for (let i = 0, length = numberInputs.length; i < length; i++) {
            if (numberInputs[i].value > 0) {
                arrValidInputs.push(numberInputs[i]);
                const maximumBrochureAmount = parseFloat(this._options.MaximumBrochureAmount);
                if (maximumBrochureAmount !== 0 && parseFloat(numberInputs[i].value) > maximumBrochureAmount) {
                    error.status = 1;
                    error.detail = 'maxNrOfItemsExceeded';
                    break;
                }
            }
        }

        // if no brochure exceeds max nr of items and all brochres have 0 items
        if (error.status === 0 && arrValidInputs.length === 0) {
            error.status = 1;
            error.detail = 'minNrOfItemsDeceded';
        }

        return error;
    }
}

export default FormValidationBrochures;
